<template>
  <slot />
</template>

<script setup lang="ts">
import { provide } from 'vue'

const props = defineProps<{
  modalId: string
}>()

provide('modalId', props.modalId)
</script>
